import React from "react";
import { Link } from "react-router-dom";
import Button from "@material-ui/core/Button";
import CssBaseline from "@material-ui/core/CssBaseline";
import TextField from "@material-ui/core/TextField";
import FormControl from "@material-ui/core/FormControl";
import Typography from "@material-ui/core/Typography";
import Grid from "@material-ui/core/Grid";
import { makeStyles } from "@material-ui/core/styles";
import Container from "@material-ui/core/Container";
import MenuItem from "@material-ui/core/MenuItem";
import InputLabel from "@material-ui/core/InputLabel";
import Select from "@material-ui/core/Select";
import { subjects_all, Grade } from "components/State&Subject/";

const useStyles = makeStyles(theme => ({
  paper: {
    marginTop: theme.spacing(5),
    display: "flex",
    flexDirection: "column",
    alignItems: "center"
  },
  avatar: {
    margin: theme.spacing(0),
    backgroundColor: theme.palette.secondary.main
  },
  form: {
    width: "100%", // Fix IE 11 issue.
    marginTop: theme.spacing(0)
  },
  submit: {
    margin: theme.spacing(3, 0, 2),
    float: "right"
  },
  button: {
    margin: theme.spacing(3, 0, 2)
  },
  formControl: {
    minWidth: "100%"
  },
  mBottom: {
    marginBottom: "20px"
  },
  mTop: {
    marginTop: "5px"
  }
}));

export default function UploadDocument() {
  const classes = useStyles();

  return (
    <Container component="main" maxWidth="md">
      <CssBaseline />
      <div className={classes.paper}>
        <form className={classes.form} noValidate>
          <Grid container spacing={2}>
            <Grid item xs={12} sm={12} className={classes.mTop}>
              <Typography>
                OTHER INSTITUTIONS ATTENDED AND CREDENTIALS
              </Typography>
            </Grid>

            <Grid item xs={12} sm={6}>
              <Typography className={classes.mBottom}>
                Baptismal Card
              </Typography>
              <TextField
                variant="outlined"
                required
                fullWidth
                type="file"
                id="fname"
                autoComplete="institution name"
                label="Upload Document"
                InputLabelProps={{ shrink: true }}
              />
            </Grid>

            <Grid item xs={12} sm={6}>
              <Typography className={classes.mBottom}>
                Olevel Certificate
              </Typography>
              <TextField
                variant="outlined"
                required
                fullWidth
                type="file"
                id="fname"
                label="Upload Document"
                autoComplete="institution name"
                InputLabelProps={{ shrink: true }}
              />
            </Grid>

            <Grid item xs={12} sm={6}>
              <Typography className={classes.mBottom}>Testimonial</Typography>
              <TextField
                variant="outlined"
                required
                fullWidth
                type="file"
                id="fname"
                label="Upload Document"
                autoComplete="institution name"
                InputLabelProps={{ shrink: true }}
              />
            </Grid>

            <Grid item xs={12} sm={6}>
              <Typography className={classes.mBottom}>
                Passport Photograph (Not less than 100kb)
              </Typography>
              <TextField
                variant="outlined"
                required
                fullWidth
                type="file"
                id="fname"
                label="Upload Document"
                autoComplete="institution name"
                InputLabelProps={{ shrink: true }}
              />
            </Grid>
            
          </Grid>

          <Button
            type="submit"
            variant="contained"
            color="primary"
            className={classes.button}
            component={Link}
            to="certificate"
          >
            Back
          </Button>
          <Button
            type="submit"
            variant="contained"
            color="primary"
            className={classes.submit}
            component={Link}
            to="occupation"
          >
            Next
          </Button>
        </form>
      </div>
    </Container>
  );
}
